import * as React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import PreviewIcon from "@mui/icons-material/Preview";
import { IconButton, Stack, Tooltip } from "@mui/material";
import { Close } from "@mui/icons-material";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  height: "90%",
  overflowY: "auto",
  width: { xs: "90%", md: "650px" },
  transform: "translate(-50%, -50%)",
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

export default function ViewModal({ item, FetchStyles, FetchItems }) {
  const [open, setOpen] = React.useState(false);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <>
      <Tooltip title="Preview">
        <IconButton color="primary" onClick={handleOpen}>
          <PreviewIcon />
        </IconButton>
      </Tooltip>
      <Modal
        open={open}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Box position="absolute" top={10} right={0}>
            <IconButton onClick={handleClose}>
              <Close />
            </IconButton>
          </Box>

          {item?.amazonFields?.amazonIframe && (
            <Stack my={1}>
              <Typography variant="h6" marginBottom={1}>
                Iframe:{" "}
              </Typography>
              <iframe
                srcDoc={item.amazonFields?.amazonIframe}
                title="Embedded Content"
                frameBorder="0"
                sandbox="allow-popups allow-scripts allow-modals allow-forms allow-same-origin"
                height={261}
                width={128}
              />
            </Stack>
          )}

          {item?.items.length > 0 && (
            <Stack my={1}>
              <Typography variant="h6">Items: </Typography>
              {item?.items.map((item, index) => {
                const foundItem = FetchItems?.items?.find(
                  (found) => found._id === item._id
                );

                return (
                  <div key={index}>
                    {foundItem ? (
                      <>{foundItem.name}</>
                    ) : (
                      <>
                        {item?.name?.charAt(0).toUpperCase() + item?.name?.slice(1).toLowerCase()}
                      </>
                    )}
                  </div>
                );
              })}
            </Stack>
          )}

          {item?.styles.length > 0 && (
            <Stack my={1}>
              <Typography variant="h6">Styles: </Typography>
              {item?.styles.map((item, index) => {
                const foundItem = FetchStyles?.find(
                  (found) => found._id === item
                );

                return (
                  <div key={index}>
                    {foundItem ? (
                      <>{foundItem.name}</>
                    ) : (
                      <>
                        {item?.charAt(0).toUpperCase() +
                          item.slice(1).toLowerCase()}
                      </>
                    )}
                  </div>
                );
              })}
            </Stack>
          )}

          {item?.amazonFields?.amazonUrl && (
            <Stack my={1}>
              <Typography variant="h6">Iframe Url: </Typography>
              <a
                href={item.amazonFields.amazonUrl}
                target="_blank"
                rel="noreferrer"
              >
                {item.amazonFields.amazonUrl}
              </a>
            </Stack>
          )}

          {item?.amazonFields?.price && (
            <Stack my={1}>
              <Typography variant="h6">
                Price:{" "}
                <Typography variant="h6" component={"span"} fontWeight={400}>
                  {item.amazonFields.price}
                </Typography>
              </Typography>
            </Stack>
          )}

          {item?.amazonFields?.itemDimensions && (
            <Stack my={1} display={"flex"}>
              {item.amazonFields.itemDimensions?.length && (
                <Box>
                  <Typography variant="h6">
                    Length:{" "}
                    <Typography
                      variant="h6"
                      component={"span"}
                      fontWeight={400}
                    >
                      {item.amazonFields.itemDimensions?.length}
                    </Typography>
                  </Typography>
                </Box>
              )}

              {item.amazonFields.itemDimensions?.width && (
                <Box>
                  <Typography variant="h6">
                    Width:{" "}
                    <Typography
                      variant="h6"
                      component={"span"}
                      fontWeight={400}
                    >
                      {item.amazonFields.itemDimensions?.width}
                    </Typography>
                  </Typography>
                </Box>
              )}

              {item.amazonFields.itemDimensions?.height && (
                <Box>
                  <Typography variant="h6">
                    Height:{" "}
                    <Typography
                      variant="h6"
                      component={"span"}
                      fontWeight={400}
                    >
                      {item.amazonFields.itemDimensions?.height}
                    </Typography>
                  </Typography>
                </Box>
              )}
            </Stack>
          )}
        </Box>
      </Modal>
    </>
  );
}
